import { inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { TranslocoPersistLangService } from '@jsverse/transloco-persist-lang';
import { of } from 'rxjs';

export const loadLang = () => {
  const translocoService = inject(TranslocoService);
  const translocoPersistLangService = inject(TranslocoPersistLangService);

  translocoService.setActiveLang(
    translocoPersistLangService.getCachedLang() ?? 'en',
  );

  return of(null);
};
